module.exports = __webpack_public_path__ + "static/media/employees.9690d2b3.gif";